import { postToIframe } from 'dibs-xdomain-poster';

export function postProjectToFA(args) {
    const { action, firmId, project, source, userId } = args;

    let installDateTimestamp = '';
    if (project.installDate) {
        const installDate = new Date(project.installDate);
        installDateTimestamp = installDate.toString();
    }

    let createdDateString = '';
    let createdDateTimestamp = '';
    if (project.createdDate) {
        const createdDate = new Date(project.createdDate);
        createdDateString = `${createdDate.getMonth() +
            1}/${createdDate.getDate()}/${createdDate.getFullYear()}`;
        createdDateTimestamp = createdDate.toString();
    }

    /* eslint-disable camelcase */
    return postToIframe('https://www.tfaforms.com/responses/processor', {
        tfa_1: project.name || '',
        tfa_2: project.serviceId || '',
        tfa_4: firmId || '',
        tfa_5: createdDateString,
        tfa_6: userId,
        tfa_7: createdDateTimestamp,
        tfa_8: source,
        tfa_9: action,
        tfa_10: installDateTimestamp,
        tfa_dbControl: 'f1419a0fb9e1fdea82506ace4d28260a',
        tfa_dbFormId: '4655499',
        tfa_dbResponseId: '',
        tfa_dbTimeStarted: Date.now(),
        tfa_dbVersionId: '5',
        tfa_referrer: window.location.href,
        tfa_switchedoff: '',
    });
    /* eslint-enable camelcase */
}
